// extracted by mini-css-extract-plugin
module.exports = {"box":"IconBox-module--box--JYwG2"};